import { LocalComponent } from "~/ecs/base"

export class NonInteractive extends LocalComponent {}

export class NonInteractiveApplied extends LocalComponent {}
